import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Layout({ user, onLogout, children }) {
  const location = useLocation();
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  
  const isTeacher = user.role === 'teacher';
  const isStudent = user.role === 'student';

  const teacherLinks = [
    { path: '/teacher/dashboard', label: 'Dashboard' },
    { path: '/teacher/students', label: 'Students & Groups' },
    { path: '/teacher/exercise-access', label: 'Exercise Access' }
  ];

  const studentLinks = [
    { path: '/student/dashboard', label: 'My Exercises' }
  ];

  const links = isTeacher ? teacherLinks : studentLinks;

  const confirmLogout = async () => {
    try {
      setLoggingOut(true);
      await onLogout();
    } finally {
      setLoggingOut(false);
      setShowLogoutConfirmation(false);
    }
  };

  return (
    <div className="app-layout">
      <nav className="navbar">
        <div className="navbar-brand">
          Web Programming LMS
        </div>
        
        <div className="navbar-links">
          {links.map(link => (
            <Link
              key={link.path}
              to={link.path}
              className={location.pathname === link.path ? 'active' : ''}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="navbar-user">
          <span>{user.fullName} ({user.role})</span>
          <button
            type="button"
            aria-haspopup="dialog"
            onClick={() => setShowLogoutConfirmation(true)}
          >
            Odjava
          </button>
        </div>
      </nav>

      <main className="main-content">
        {children}
      </main>

      {showLogoutConfirmation && (
        <div
          className="logout-confirmation-backdrop"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget && !loggingOut) {
              setShowLogoutConfirmation(false);
            }
          }}
        >
          <section
            className="logout-confirmation-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="logout-confirmation-title"
            aria-describedby="logout-confirmation-description"
            onKeyDown={(event) => {
              if (event.key === 'Escape' && !loggingOut) {
                setShowLogoutConfirmation(false);
              }
            }}
          >
            <div className="logout-confirmation-icon" aria-hidden="true">↪</div>
            <h2 id="logout-confirmation-title">Želite li se odjaviti?</h2>
            <p id="logout-confirmation-description">
              Jeste li sigurni da se želite izlogirati?
            </p>
            <div className="logout-confirmation-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowLogoutConfirmation(false)}
                disabled={loggingOut}
                autoFocus
              >
                Ostani prijavljen/a
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={confirmLogout}
                disabled={loggingOut}
              >
                {loggingOut ? 'Odjavljujem…' : 'Da, izlogiraj me'}
              </button>
            </div>
          </section>
        </div>
      )}
    </div>
  );
}

export default Layout;
